import { Input } from "@/components/ui/input";
import { isValidIban } from "@/lib/iban";

// Campo IBAN con validazione formato + checksum Mod-97 e stato di errore inline.
export const IbanField = ({ label, value, onChange, required = false, testId, requiredEmpty = false, className = "" }) => {
  const v = (value || "").trim();
  const invalid = v.length > 0 && !isValidIban(v);
  const showRed = invalid || requiredEmpty;
  return (
    <div>
      {label && (
        <label className="text-[11px] uppercase tracking-wide text-muted-foreground">
          {label}{required && <span className="text-red-500"> *</span>}
        </label>
      )}
      <Input
        data-testid={testId}
        value={value || ""}
        onChange={(e) => onChange(e.target.value.toUpperCase())}
        placeholder="IT60 X054 2811 1010 0000 0123 456"
        className={`h-9 mt-1 font-mono uppercase ${showRed ? "border-red-400 focus-visible:ring-red-400" : ""} ${className}`}
      />
      {invalid && (
        <p className="text-[11px] text-red-500 mt-1" data-testid={testId ? `${testId}-error` : undefined}>
          IBAN non valido: controlla il formato e le cifre di controllo.
        </p>
      )}
    </div>
  );
};

export default IbanField;
